/**
 * Mailbox connections API — additional connected mailboxes (Gmail).
 */
import { apiGet, apiPost, apiDelete } from './client';

export type MailboxConnectionStatus = 'active' | 'reauth_required' | 'error' | 'disconnected';

export interface MailboxConnection {
  id: string;
  provider: 'microsoft' | 'google';
  email: string;
  status: MailboxConnectionStatus;
  lastSyncAt: string | null;
  lastError: string | null;
  connectedAt: string;
}

export interface MailboxConnectionsResponse {
  connections: MailboxConnection[];
}

export interface ScanResponse {
  queued: number;
  daysBack: number;
}

export async function listMailboxConnections(): Promise<MailboxConnectionsResponse> {
  return apiGet<MailboxConnectionsResponse>('/api/mailbox-connections');
}

export async function disconnectMailboxConnection(connectionId: string): Promise<{ disconnected: boolean }> {
  return apiDelete<{ disconnected: boolean }>(`/api/mailbox-connections/${connectionId}`);
}

export async function scanMailboxConnection(connectionId: string, daysBack?: number): Promise<ScanResponse> {
  return apiPost<ScanResponse>(
    `/api/mailbox-connections/${connectionId}/scan`,
    daysBack !== undefined ? { daysBack } : {},
  );
}
